/** Site copy — English / Hinglish (toggle EN in header). Shape must mirror hindiContent.js */
const englishContent = {
  common: {
    brandAnchor: 'Learn. Earn.<br/> Stay Protected.',
    mail: 'humproecosystem@gmail.com',
    domain: 'humpro.in',
    rightsSuffix: 'HumPro. All rights reserved.',
    /** WhatsApp + floating “Call”: digits only with country code, no + (e.g. 919876543210). Env REACT_APP_CONTACT_PHONE overrides. */
    contactPhoneE164: '9263123137',
  },
  floatingContact: {
    groupLabel: 'Quick contact',
    call: 'Call HumPro',
    whatsapp: 'Message on WhatsApp',
    email: 'Email HumPro',
    callViaContact: 'Open contact page to call us',
    whatsappViaContact: 'Open contact page for WhatsApp',
  },
  header: {
    nav: {
      home: 'Home',
      about: 'About',
      courses: 'Courses',
      consultancy: 'Consultancy',
      careers: 'Careers/Jobs',
      contact: 'Contact Us',
    },
    brandAria: 'HumPro Home',
    menuOpen: 'Open menu',
    menuClose: 'Close menu',
    langGroupAria: 'Choose site language, English or Hindi',
    langHiTitle: 'Hindi, full site content in Devanagari',
    langEnHidden: 'English',
    langHiHidden: 'Hindi',
  },
  footer: {
    tagline: 'Learn. Earn. Stay Protected. — education, income, and protection for every Indian family.',
    navSite: 'Site',
    navMore: 'More',
    navHome: 'Home',
    navAbout: 'About',
    navCourses: 'Courses',
    navConsultancy: 'Consultancy',
    navCareers: 'Careers',
    navContact: 'Contact',
    privacy: 'Privacy',
    terms: 'Terms',
    linkedin: 'LinkedIn',
    youtube: 'YouTube',
    instagram: 'Instagram',
    facebook: 'Facebook',
  },
  home: {
    hero: {
      eyebrowHi: 'शिक्षा · सुरक्षा · सशक्तिकरण',
      eyebrowEn: 'Education · Protection · Empowerment',
      title: 'Your Family Deserves More Than Scattered Promises.',
      titleLine2: 'HumPro Gives Them Everything — In One Place.',
      lead:
        'Most Indian families chase three different experts for education, work, and insurance — and still get left behind. HumPro brings all three together, in the language you speak at home, at prices that respect your effort.',
      playAria: 'Download the HumPro app',
      playSmall: 'Download',
      playStrong: 'HumPro App',
      exploreCourses: 'Explore Courses',
      talkToAdvisor: 'Talk to a HumPro Advisor — Free',
      photoAlt: 'HumPro — support for education, work, and family protection across India.',
      pillTextHi: 'बिहार से शुरू। भारत के लिए।',
      pillTextEn: 'Started in Bihar. Built for every Indian family.',
    },
    focusHiddenTitle: 'How HumPro helps families',
    focusCards: {
      courses: {
        title: 'Skills that open real doors',
        body:
          'CBSE and Bihar Board support, English communication, and skill training — taught by mentors who measure success by your growth, not their commission.',
        linkLabel: 'View courses',
      },
      careers: {
        title: "Work that pays what you're worth",
        body:
          'Verified roles across Bihar and 7 major cities. No middlemen. No fake listings. Just honest work for people who are ready to show up.',
        linkLabel: 'View careers',
      },
      consultancy: {
        title: 'Insurance explained like family — not fine print',
        body:
          "Term, health, and accident cover — explained in plain Hindi and English until you fully understand what you're buying and why it protects your family.",
        linkLabel: 'View consultancy',
      },
    },
    why: {
      placeholderAria: 'Image placeholder. Final export size 560 by 700 pixels.',
      placeholderKicker: 'Image area',
      placeholderDims: '560 × 700 px',
      placeholderNote: 'Wireframe, replace later',
      title: 'Three problems. One home. Zero runaround.',
      lead: '',
      reasons: [
        'Every rupee, every lesson, every policy — explained before you commit.',
        'We speak Hindi. We speak your reality. Guidance that feels like a conversation, not a sales lecture.',
        "Your family's insurance — chosen by you, explained by us, never pushed on you.",
        'Built for the families who work hardest and get the least help. That changes here.',
        'One trusted team for everything — so you stop running and start growing.',
      ],
      closing: '“आज समझ। कल बदलाव। हमेशा साथ।” · “Today, clarity. Tomorrow, change. Always together.”',
      photoAlt: 'Families choosing HumPro for education, livelihood, and protection guidance.',
    },
    testimonial: {
      kicker: 'From a HumPro family',
      title: 'One family. Three problems. One HumPro call.',
      quote:
        "We used to run between a tuition centre, a job agent, and an insurance office — and still felt lost. HumPro explained our son's English course, helped my husband find verified site work in Patna, and walked us through health cover in Hindi. For the first time, someone stayed with us past the sale. That's when we knew HumPro wasn't a service. It was a partner.",
      author: 'Sunita & Ravi K.',
      location: 'Patna, Bihar',
      detail: 'HumPro user · Courses + Jobs + Insurance',
      photoAlt: 'A family supported by HumPro across learning, work, and protection.',
    },
    founder: {
      kicker: 'Message from the founder',
      title: 'Built on faith in every family',
      quote:
        '“What you believe, you become. HumPro stands on this truth. Every family deserves a dignified future.”',
      cite: 'Gholam Noorani, Founder, HumPro Ecosystem',
    },
    company: {
      kicker: 'About HumPro',
      title: 'One home. Three promises. Education, income, and protection.',
      lead:
        'Most families chase three different experts and still get left behind. HumPro puts it all under one roof — in the language you already speak at home.',
      chipsAria: 'HumPro business areas',
      chips: ['Education support', 'Jobs and partnerships', 'Insurance consultancy'],
      foot: 'Learn. Earn. Stay Protected. — our anchor for every household across Bihar and India.',
      cta: 'Learn more about HumPro',
      photoAlt: 'HumPro team and community — building one ecosystem for Indian families.',
    },
  },
  about: {
    heroEyebrow: 'HumPro Ecosystem',
    heroTitle: 'About HumPro',
    heroLead:
      'Built in Bihar. Built for Bharat. Because every family deserves the same tools the privileged take for granted.',
    heroPhotoAlt: 'Communities across Bihar and India building stronger futures with HumPro.',
    standTitle: 'What we stand for',
    standStart: 'HumPro helps families build a better life by bringing together',
    standEdu: 'education',
    standEduNote: '(learning that opens doors),',
    standWork: 'meaningful work',
    standWorkNote: '(jobs and partnerships you can trust), and',
    standProtection: 'protection',
    standEnd:
      '(health, term, and accident cover explained plainly so you choose what is right, not what is rushed).',
    splitPlaceholderAria: 'About HumPro image placeholder. Final export size 560 by 700 pixels.',
    splitTitle: 'What families can count on from us',
    splitLead:
      "We don't sell you three separate things. We walk with you through all three — because a family's life doesn't come in separate departments.",
    splitPhotoAlt: 'Families counting on HumPro for education, work, and protection in one place.',
    splitBullets: [
      'We say plainly what costs what, who teaches or advises you, and what happens next before you invest evenings or savings.',
      'Education, work, and insurance stay in one ecosystem so you are not bounced between three different pitches that never talk to each other.',
      'We design touchpoints for real households: school-night pacing, rural connectivity realities, and budgets that cannot absorb surprise add-ons.',
      'You always get a path to follow up by email with real people who read it.',
    ],
    splitClosing:
      "“विश्वास पहले, दिखावा नहीं।” · “We'd rather earn your trust slowly than lose it fast with a pretty pitch.”",
    founderLabel: 'The founder',
    founderName: 'Gholam Noorani',
    founderRole: 'Founder & CEO, HumPro Ecosystem · Bihar',
    founderQuote:
      '“I watched families in Bihar run in three directions just to survive — education here, work there, insurance somewhere else. No one was putting it together for them. So I did.”',
    founderCite: '— Gholam Noorani, Founder',
    founderBio:
      'Gholam started HumPro not from a boardroom, but from a real problem he watched his community face every day. Raised in Bihar, he saw hardworking families fall behind — not because they lacked ambition, but because no one gave them the right tools in their own language, at a price they could trust. HumPro is his answer. One ecosystem. One trusted name. For every Indian household that deserves better than scattered promises.',
    founderClosing: "“One man's belief. A million families' future.”",
    ctaTitle: 'Ready to connect?',
    ctaText:
      'Use the contact page to send your name, number, topic, and message. A real person reads what you write.',
    ctaHome: 'Back to home',
    ctaContact: 'Go to contact',
  },
  coursesPage: {
    heroEyebrow: 'Courses',
    heroTitle: 'Real Skills. Real Teachers. Prices That Respect Your Hard Work.',
    heroLead:
      'No padded syllabi. No fake urgency. Just courses built around what your child, your family, and your future actually need — taught by people who show up.',
    heroPhotoAlt: 'Students learning practical skills with HumPro mentors.',
    bullets: [
      'CBSE and Bihar Board–friendly support, explained in everyday language.',
      "Home tuition and English help shaped around your child's level and schedule.",
      'Simple choices — add or change courses anytime using the list below.',
    ],
    backHome: '← Back to home',
    catalogTitle: 'What we offer',
    enquireLink: 'Enquire about this course',
    items: [
      {
        course_id: 'C001',
        course_title: 'English Communication Class',
        course_description:
          'Build confident spoken English, daily conversation, grammar clarity, and interview communication through practical exercises.',
        icon: 'english_icon.png',
      },
      {
        course_id: 'C002',
        course_title: 'Home Tuition',
        course_description:
          'We provide all kinds of home tuition for all subjects, customized to student needs at home.',
        icon: 'home_tuition_icon.png',
      },
      {
        course_id: 'C003',
        course_title: 'Skill Development Training',
        course_description:
          'Hands-on training for tutoring and tutor skills, plus mehndi skills training to support self-employment and income growth.',
        icon: 'home_tuition_icon.png',
      },
    ],
  },
  careersPage: {
    heroEyebrow: 'Careers / Jobs',
    heroTitle: 'Kaam Dhundo. Kaam Banao. Income Badhao.',
    heroLead:
      "Verified roles. No middlemen. No false promises. Whether you're in a village or a metro — if you want to work with dignity, HumPro finds it with you.",
    heroPhotoAlt: 'Workers and job seekers finding verified roles through HumPro.',
    heroTrust: '“Aapka bharosa aur vishwas hi humari pehchaan hai.”',
    contactNow: 'Contact now',
    heroCtaNote:
      'Opens the contact page with Jobs / careers pre-selected. Tell us your trade, city, and availability.',
    citiesTitle: 'Cities where we are active today',
    citiesLead:
      '“Chahe gaon ho ya sheher…” · From Bihar\'s roots to India\'s biggest cities — your work finds you here.',
    cities: ['Patna', 'Noida', 'Delhi', 'Hyderabad', 'Pune', 'Ahmedabad', 'Surat', 'Mumbai'],
    offersTitle: 'What we offer',
    offerings: [
      {
        id: 'manpower',
        title: 'Manpower for construction & industry',
        body:
          'We supply reliable teams to civil contractors, construction sites, and sariya / shuttering work — scheduled crews who understand site safety and pace, not random daily-wage chaos.',
      },
      {
        id: 'listings',
        title: 'Verified job pathways',
        body:
          'Beyond sites: verified openings across government, private, NGO, and construction sectors — so you are not chasing fake listings or paying middlemen for “guarantees”.',
      },
      {
        id: 'partner',
        title: 'HumPro Partner & freelance',
        body:
          'Part-time income with HumPro in your area — share courses, support insurance guidance, and earn commissions. Digital skills? Connect with clients and work from home when it fits.',
      },
    ],
    specialTitle: 'Special support for hard workers',
    specialText:
      'Where the programme allows, HumPro lines up free education, free insurance orientation, and free protection guidance for workers who stay in the journey — so your household is safer while you earn. T&C apply; registration may be required for some benefits.',
  },
  consultancyPage: {
    heroEyebrow: 'Consultancy',
    heroTitle: 'Parivar Ki Suraksha — Seedhi Baat, Koi Confusion Nahi.',
    heroLead:
      "Insurance shouldn't feel like a trap. We explain term, health, and accident cover in plain words — so you protect your family, not just sign a document.",
    heroPhotoAlt: 'Families receiving clear insurance guidance from HumPro consultants.',
    contactNow: 'Contact now',
    heroCtaNote:
      'Opens contact with Insurance / consultancy selected. Ask for a free orientation call.',
    plansTitle: 'Three plans that actually matter — chosen by you, explained by us, never pushed.',
    plansLead:
      'Kaunsa plan aapke liye sahi hai? Yahi hum bina policy push kiye batate hain — aligned with your HumPro English brief.',
    plans: [
      {
        id: 'term',
        title: 'Term insurance',
        body:
          'Financial security for your family — higher cover at sensible cost. We walk through when to start, how much cover matches your goals, and what to ignore in noisy ads.',
      },
      {
        id: 'health',
        title: 'Health insurance',
        body:
          'Hospital bills should hit the policy, not your savings. We compare network hospitals, room limits, co-pay, and add-ons so you pick a plan that survives real illness.',
      },
      {
        id: 'accident',
        title: 'Accident cover',
        body:
          'Life is unpredictable. A compact accident policy cushions income loss and emergency costs — explained plainly, without pushing products you do not need.',
      },
    ],
    stepsTitle: 'How it works — 3 simple steps',
    steps: [
      {
        n: '1',
        title: 'Baat karo',
        body: 'Message on WhatsApp or use the contact page — consultation is free; no “consultation fees” trap.',
      },
      {
        n: '2',
        title: 'Samjho',
        body: 'We listen to your situation first, then suggest only what fits — term, health, accident, or a mix.',
      },
      {
        n: '3',
        title: 'Protect karo',
        body: 'Choose the policy with clarity. Stay for MasterClass-style sessions on income and budgeting when you are ready.',
      },
    ],
    masterLineBefore: 'Sirf insurance nahi —',
    masterLineStrong: 'HumPro MasterClass',
    masterLineAfter:
      'sessions cover income growth, budgeting, and small-business basics so protection sits next to earning power.',
    quoteBody:
      '“Aaj ka ek sahi decision kal ki hazaar takleefon se bachata hai. Parivar ke liye sochna — yahi asli sashaktikaran hai.”',
    quoteFooter: '— HumPro Consultancy Team',
  },
  contactPage: {
    heroEyebrow: 'Contact',
    heroPhotoAlt: 'HumPro MasterClass session with community members learning together.',
    heroTitle: 'Judein Hum Se — Hum Hain Yahaan',
    heroLead:
      'Got a question? A real person reads what you send — straight, quick, and with care. We are not a giant helpdesk where you wait seven days for a template reply.',
    heroTagline: '“Aapka bharosa aur vishwas hi humari pehchaan hai.”',
    formTitle: 'Message bhejo',
    formIntroBefore:
      'Fields: naam, phone / WhatsApp, topic, and message. If direct submit does not work, you can use “Send by email instead”. Primary inbox:',
    asideTitle: 'Other ways',
    asideWhatsappStrong: 'WhatsApp',
    asideWhatsapp:
      '— fastest for short questions (add your business number when ready).',
    asideEmailStrong: 'Email',
    asideEmailAfter: 'for longer notes, partnerships, or media.',
    asideAppStrong: 'App',
    asideApp:
      '— courses, updates, and support in one place once the app link is live on the store.',
    asideFoot: '“Akele mat jao — HumPro community mein aao. Yahan sabka swagat hai.”',
  },
  contact: {
    form: {
      purposeOptions: [
        { value: 'job', label: 'Jobs / careers' },
        { value: 'consultancy', label: 'Insurance / consultancy' },
        { value: 'courses', label: 'Courses / tuition' },
        { value: 'admission', label: 'Admission' },
        { value: 'partnership', label: 'Partnership' },
        { value: 'other', label: 'Other' },
      ],
      name: 'Name',
      namePh: 'Your name',
      phone: 'Phone / WhatsApp',
      phonePh: 'e.g. +91 98765 43210',
      topic: 'Topic',
      topicPlaceholder: 'Select topic',
      message: 'Message',
      messagePh: 'How can we help?',
      submit: 'Send message',
      submitting: 'Sending…',
      sent: 'Thank you — your message was saved. We will get back to you soon.',
      fallbackEmail: 'We opened your email app so you can send a copy to our team.',
      sheetFailed:
        'We could not submit your message right now. You can still send it by email:',
      emailInstead: 'Send by email instead',
      hintSheetBefore: 'Your message is submitted directly. If that does not work from your network, your email app opens to ',
      hintSheetAfter: ' as a backup. We reply as soon as we can.',
      hintEmailBefore: 'Opens your email app to send to ',
      hintEmailAfter: '. We reply as soon as we can — no long ticket queues.',
    },
    popup: {
      title: 'Contact HumPro',
      hintBefore: 'For the full form and other options, visit the ',
      contactPageLink: 'Contact page',
      hintAfter: '. Quick send submits directly; if it does not work, your email app opens.',
      closeThanks: 'Close',
      name: 'Name',
      phone: 'Contact number',
      topic: 'Topic',
      message: 'Message',
      messagePh: 'How can we help you?',
      cancel: 'Cancel',
      submit: 'Submit',
    },
  },
  upcoming: {
    status: 'HumPro app is live',
    title: 'HumPro Has Its Own App Now',
    subtitle:
      'Keep learning, keep growing. Download the HumPro app for courses, careers support, and insurance guidance — all in one place.',
    playAria: 'Download the HumPro app',
    playSmall: 'Download',
    playStrong: 'HumPro App',
    back: '← Back to home',
  },
  privacyPage: {
    title: 'Privacy Policy',
    updated: 'Last updated: May 2026',
    intro:
      'At HumPro, we respect your privacy. This policy explains what information we collect, why we collect it, and how we protect it.',
    sections: [
      {
        heading: 'Information we collect',
        body:
          'When you contact us, we may collect your name, phone number, topic, and message. If you email us directly, we receive the details you share in your email.',
      },
      {
        heading: 'How we use your information',
        body:
          'We use your information only to respond to your enquiry, provide support, and improve our services. We do not sell your personal data.',
      },
      {
        heading: 'Data sharing',
        body:
          'We may use trusted service providers to run website functions. They only get access required to provide those services.',
      },
      {
        heading: 'Data security',
        body:
          'We use reasonable technical and operational safeguards to protect your information from unauthorized access and misuse.',
      },
      {
        heading: 'Your rights',
        body:
          'You can request correction or deletion of your personal information by contacting us at humproecosystem@gmail.com.',
      },
    ],
  },
  termsPage: {
    title: 'Terms and Conditions',
    updated: 'Last updated: May 2026',
    intro:
      'These terms govern your use of the HumPro website. By using this site, you agree to these terms.',
    sections: [
      {
        heading: 'Use of content',
        body:
          'Website content is for general information about our education, career, and consultancy services. Please do not copy or reuse content without permission.',
      },
      {
        heading: 'Service information',
        body:
          'We try to keep information accurate and updated. However, course details, service availability, and plans may change over time.',
      },
      {
        heading: 'User responsibility',
        body:
          'Please share correct information in contact forms and avoid using this website for unlawful, abusive, or misleading activities.',
      },
      {
        heading: 'External links',
        body:
          'Our site may include external links such as app store or social platforms. We are not responsible for third-party website content.',
      },
      {
        heading: 'Contact',
        body:
          'For questions regarding these terms, contact us at humproecosystem@gmail.com.',
      },
    ],
  },
};

export default englishContent;
